import { useLoadingStore, selectLoading } from '@/modules/shared/stores/loadingStore'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

const AddAnotherDayActivityFooter = () => {
  const { t } = useLocalize()
  const loading = useLoadingStore(selectLoading)
  return (
    <div className="tw-flex tw-justify-end tw-border-t tw-border-base-300">
      <button
        disabled={loading}
        type="submit"
        className={`tw-m-4 tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80 `}
      >
        {t('operation.confirm')}
      </button>
    </div>
  )
}

export default AddAnotherDayActivityFooter
